export const REQUEST_ACTION_TYPE_SUFFIX = '_REQUEST';
export const SUCCESS_ACTION_TYPE_SUFFIX = '_SUCCESS';
export const FAILURE_ACTION_TYPE_SUFFIX = '_FAILURE';
